import bg from 'asset/home/carbon.jpg';
import PcseoHomeHospital from '@jdh-cargo/block-pcseo-home-hospital';
import PcseoDoctorSearch from '@jdh-cargo/block-pcseo-doctor-search';
// import { Link, animateScroll as scroll } from "react-scroll";
import styles from './index.less';
// import PcseoRecommondCard from '@jdh-cargo/block-pcseo-recommond-card';
import ArticleCard from '@jdh-cargo/block-content-article-card';
import InquiryCard from '@jdh-cargo/block-content-inquiry-card';
import AnswerCard from '@jdh-cargo/block-content-answer-card';

// import Affix from './affix';
import { homeNav } from './homeNav';
import { Template } from './template';
import { setHospitalTDK } from 'utils/hospital';
import { targetLink } from 'utils';

export const Home = () => {
  setHospitalTDK(
    '京东健康 - 互联网医院',
    '京东健康互联网医院,网上预约挂号,网上问诊',
    '京东健康互联网医院提供在线问诊、慢病管理、加号等服务的互联网医疗平台，患者在家看专家，线上处方，线上药房，药品配送到家。私人医生长期照护，体检报告专家解读，给你专业的分析和建议。大三甲医院的专家号，一号难求，挂号难，京东健康互联网医院免费加号，让患者轻松看上大专家，找对医生挂对号！'
  )
  return (
    <Template isDetail={false}>
      <div id={homeNav[0].id}>
        <PcseoHomeHospital
          clickCallback={() => {
            targetLink("/hospitalList/all")
          }}
          moreUrl="/hospitalList/all"
        />
      </div>
      <div id={homeNav[1].id} className={styles.doctor}>
        <PcseoDoctorSearch
          moreClickCallback={() => {
            targetLink("/department/all-all")
          }}
          moreUrl="/department/all-all"
        />
      </div>
      <div id={homeNav[2].id} style={{paddingBottom:'16px'}}>
        {/* @ts-ignore */}
        <AnswerCard moreUrl='answerList' paging={false}/>
      </div>
      <div id={homeNav[3].id} style={{paddingBottom:'16px'}}><InquiryCard moreUrl='inquiryList' paging={false}  hideWhenAnswerListNone={true}/></div>
      <div id={homeNav[4].id} style={{paddingBottom:'16px'}}><ArticleCard moreUrl='articleList' paging={false}  hideWhenAnswerListNone={true}/></div>
    </Template>
  )
};
